import './src/styles/global.css'
import React from 'react'
import { WrapPageElementBrowserArgs } from 'gatsby'
// import { Txs } from "./src/pages/island"
import ThemeContext from './src/components/ThemeContext'

import Layout from './src/components/layout/Layout'

export const wrapPageElement: React.FC<WrapPageElementBrowserArgs> = ({
  element,
  props,
}) => {
  return <Layout {...props}>{element}</Layout>
}

// export const wrapRootElement = ({ element }) => (
//   <ThemeContext>{element}</ThemeContext>
// )